<template>
  <div class="reporting-grid-header">
    <BreakdownLegend
      :group-bys="availableGroupBys"
      :breakdown="activeInsightGroupHierarchy"
      @onChange="onGroupByChange"
      @onDelete="onDeleteGroupBy"
    />

    <span
      class="clickable quick-insights-btn"
      @click="$emit('openQuickInsightsToolPanel')"
    >
      <i class="fa fa-superpowers m-r-5" />
      Quick Insights
    </span>

    <ChartSelector
      v-if="!hideChartSelector"
      :selected-chart-type="selectedChartType"
      @onChartTypeChange="selectChartType"
    />

    <!-- <ExportCsv
      v-if="canExport"
      :disabled="false"
      :report-id="savedReport.id"
      @exportFull="$emit('exportFull')"
      @exportSelectCols="$emit('exportSelectCols')"
      @scheduleReportDelivery="$emit('scheduleReportDelivery', arguments[0])"
    /> -->
    <span
      v-if="canExport"
      class="export-csv-btn"
      @click="$emit('exportSelectCols')"
    >
      <i class="fa fa-download m-r-5" />
      {{ $t('EXPORT_CSV') }}
    </span>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import { accountsService } from '@/angularBridgeCode/ringbaPortal.servicesModule';
import sharedMessages from '@/core/locales';
import messages from './locales';
import ExportCsv from './ExportCsv';
import ChartSelector from './ChartSelector';
import BreakdownLegend from './BreakdownLegend';

export default {
  name: 'ReportingGridHeader',
  components: { ChartSelector, ExportCsv, BreakdownLegend },
  props: {
    selectedChartType: {
      type: String,
      default: 'table'
    },
    selectedGroupBy: {
      type: Object,
      default() {
        return {
          field: 'campaignName',
          displayName: 'Campaign'
        };
      }
    },
    hideChartSelector: {
      type: Boolean,
      default: false
    },
    disableExport: {
      type: Boolean,
      default: false
    },
    savedReport: {
      type: Object,
      default() {
        return {
          name: '',
          id: null
        };
      }
    },
    availableGroupBys: {
      type: Object,
      default() {
        return null;
      }
    }
  },
  data() {
    return {
      canExport: false
    };
  },

  computed: {
    ...mapGetters('reporting', [
      'activeInsightGroupHierarchy'
    ])
  },

  created () {
    this.canExport = accountsService.hasAccess('CallLogFileExportJob', 'CREATE');
  },

  methods: {
    selectChartType(type) {
      this.$emit('onChartTypeChange', type);
    },
    onGroupByChange(groupBy, index) {
      this.$emit('onGroupByChange', groupBy, index);
    },
    onDeleteGroupBy(index) {
      this.$emit('onDeleteGroupBy', index);
    }
  },
  i18n: {
    locale: 'en',
    messages,
    sharedMessages
  }
};
</script>

<style lang="scss" scoped>
.reporting-grid-header {
  display: flex;
  align-items: center;
  min-height: 35px;
  background-color: var(--component-widget-panel__holder-bg);
}

.insights-group-by-dropdown {
  height: 100%;
  min-width: $insights-group-by-btn-min-width;
}

.quick-insights-btn {
  padding: 8px 10px;
  border-left: 1px solid $reporting-settings-v2-grid-header-buttons-border-color;

  &:hover {
    color: var(--contrast);
  }
}

.export-csv-btn {
  border-left: 1px solid $reporting-settings-v2-grid-header-buttons-border-color;
  cursor: pointer;
  padding: 8px 10px;
  display: inline-flex;
  align-items: center;

  &:hover {
    color: var(--contrast);
  }
}
</style>